// extracted by mini-css-extract-plugin
var _1 = "FiatFormStyle-module__agreementsWrapper___vFaqz";
var _2 = "FiatFormStyle-module__ant-input-affix-wrapper___sxv1i";
var _3 = "FiatFormStyle-module__ant-input-affix-wrapper___sxv1i";
var _4 = "FiatFormStyle-module__checkboxWraper___tjphO";
var _5 = "FiatFormStyle-module__fiatForm___WJnwa";
var _6 = "FiatFormStyle-module__label___c8Ea1";
var _7 = "FiatFormStyle-module__transactionFees___MAtBX";
var _8 = "FiatFormStyle-module__withdrawAmountWrapper___yjbas";
export { _1 as "agreementsWrapper", _2 as "ant-input-affix-wrapper", _3 as "antInputAffixWrapper", _4 as "checkboxWraper", _5 as "fiatForm", _6 as "label", _7 as "transactionFees", _8 as "withdrawAmountWrapper" }
